import React, { useContext, memo } from 'react';
import { LayoutContext } from '../../../contexts/layoutContext';
import { useRecipeQuery } from '../../../generated/graphql';
import { isEmpty } from '../../../utils/helper';
import Recipe from '../../shared/recipe';
import { LogoLoading } from '../../shared/loading';
import { RecipeActiveTimeProvider } from '../../../utils/customHooks/useRecipeActiveTimeTracker';

const EditSubRecipe = () => {
  const { selectedSubRecipe, selectedVenueObject } = useContext(LayoutContext);
  const { data, loading, error } = useRecipeQuery({
    variables: {
      input: {
        venueId: selectedVenueObject?.id || '',
        recipeId: selectedSubRecipe || '',
      },
    },
  });

  let selectedVersion = data?.recipe.recipe?.recipeVersions.find(
    (version) => version.selected
  );

  if (!data || loading || error) {
    return <LogoLoading size={60} />;
  }

  if (!isEmpty(data?.recipe.recipe) && !isEmpty(selectedVersion)) {
    return (
      <RecipeActiveTimeProvider>
        <Recipe recipe={data?.recipe.recipe!} recipeVersion={selectedVersion} />
      </RecipeActiveTimeProvider>
    );
  }
  return (
    <RecipeActiveTimeProvider>
      <Recipe />;
    </RecipeActiveTimeProvider>
  );
};

export default memo(EditSubRecipe);
